export const getCookieByName = (name: string) => {
  const regex = new RegExp('(?:^|;)\\s*'.concat(name, '\\s*=\\s*([^;]+)'));

  const matches = regex.exec(document.cookie);
  return matches ? matches[1] : undefined;
};
